import { render } from "./default-templates.vue?vue&type=template&id=5fe54d30&scoped=true"
import script from "./default-templates.vue?vue&type=script&lang=js"
export * from "./default-templates.vue?vue&type=script&lang=js"

import "./default-templates.vue?vue&type=style&index=0&id=5fe54d30&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe54d30"]])

export default __exports__